import type { AxiosResponse } from 'axios';

export const unwrapAxiosResponse = <T>(response: AxiosResponse<T>) =>
  response.data;
